"use client";

import { useEffect } from "react";

/**
 * Registers the hand-rolled service worker (/sw.js) on page load.
 * Rendered once in app/layout.tsx.
 * Guards for browser support and window availability.
 */
export default function ServiceWorkerRegistration() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;

    const register = () => {
      navigator.serviceWorker.register("/sw.js").catch((err) => {
        // Non-fatal — app works without SW.
        console.warn("Service worker registration failed:", err);
      });
    };

    // React effects run after hydration, which is after the window "load" event
    // has already fired. Register immediately if the page is already loaded;
    // otherwise wait for the load event.
    if (document.readyState === "complete") {
      register();
    } else {
      window.addEventListener("load", register, { once: true });
    }
  }, []);

  return null;
}
